import i18nFunctions from "client/utils/i18n";
import FireBase from "client/services/fireBase/apis";

const onPageInit = async (props) => {
  const { i18n } = i18nFunctions;
  const { dataExists, progressDataReceived, currentUser } = props;

  const onPageInitProps = {
    loadingText: i18n("loading.text"),
    viewCourseButton: {
      label: i18n("button.view.course", {
        person: { en: "Raheel", ur: "راحیل" },
      }),
    },
  };

  const courses = await FireBase.getCourses();

  if (Array.isArray(courses) && courses.length !== 0) {
    onPageInitProps["coursesData"] = courses;
  }

  if (!dataExists) {
    const userProgress = await FireBase.getUserProgress({ currentUser });

    const { userData: progressData } = userProgress[0];

    onPageInitProps["progressData"] = progressData;
  } else {
    onPageInitProps["progressData"] = progressDataReceived;
  }

  return onPageInitProps;
};

const functions = { onPageInit };

export default functions;
